export default __webpack_public_path__ + "Trash.f0d69a7332d24f2dd1f288a7eaa20ac5.svg";